const focusReturnTarget = (active: Element | null): HTMLElement | undefined => {
  if (!(active instanceof HTMLElement)) {
    return undefined
  }
  const menuButtonId = active.closest('[role="menu"]')?.getAttribute('aria-labelledby')
  const menuButton = menuButtonId ? active.ownerDocument.getElementById(menuButtonId) : null
  return menuButton ?? active
}

export const createFocusReturn = () => {
  let opener: HTMLElement | undefined

  const captureOpener = () => {
    opener = focusReturnTarget(document.activeElement)
  }

  const returnFocus = (event: Event, preferred?: HTMLElement) => {
    const target = [preferred, opener].find((el) => el?.isConnected)
    if (target) {
      event.preventDefault()
      target.focus({ preventScroll: true })
    }
  }

  return { captureOpener, returnFocus }
}
